/**
 * Data Backup module — request validators.
 */
import { z } from 'zod';
export const BackupDestinationKindSchema = z.enum(['r2', 'drive', 'local']);
export const BackupTriggerSchema = z.enum(['scheduled', 'manual', 'retry']);
export const BackupStatusSchema = z.enum(['running', 'completed', 'failed', 'pruned']);
export const BackupRetentionModeSchema = z.enum(['simple', 'tiered']);
export const BackupConfigInputSchema = z
    .object({
    enabled: z.boolean(),
    // node-cron accepts 5-field expressions (no seconds); admin UI presets
    // build these. Server-side validation happens in the route via cron.validate.
    cronExpression: z.string().min(9).max(50),
    destinationKind: BackupDestinationKindSchema,
    r2BucketName: z.string().max(200).nullable(),
    r2PathPrefix: z.string().max(200).nullable(),
    driveFolderUrl: z.string().url().max(500).nullable(),
    localMountPath: z.string().max(500).nullable(),
    retentionMode: BackupRetentionModeSchema,
    retentionKeepCount: z.number().int().min(3).max(365),
    retentionTierDaily: z.number().int().min(0).max(90),
    retentionTierWeekly: z.number().int().min(0).max(52),
    retentionTierMonthly: z.number().int().min(0).max(60),
    encryptionEnabled: z.boolean(),
})
    .partial()
    .refine((d) => Object.keys(d).length > 0, {
    message: 'At least one field must be provided',
});
export const BackupPassphraseUpdateSchema = z.object({
    passphrase: z.string().min(16).max(200),
});
export const BackupDestinationTestSchema = z
    .object({
    destinationKind: BackupDestinationKindSchema,
    r2BucketName: z.string().max(200).optional(),
    r2PathPrefix: z.string().max(200).optional(),
    driveFolderUrl: z.string().url().max(500).optional(),
    localMountPath: z.string().max(500).optional(),
});
export const BackupIdParamSchema = z.object({
    id: z.string().uuid(),
});
export const BackupHistoryQuerySchema = z.object({
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).optional(),
});
//# sourceMappingURL=backup.schema.js.map